import '../../form/form-submit-ajax';
import '../../../styles/stock/detail.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/css/pagination';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

import Swiper from 'swiper';
import { Keyboard, Navigation, Pagination, Thumbs } from 'swiper/modules';

import { Fancybox } from '@fancyapps/ui';
import '../../components/flowbite/drawer';
import { StockEvents } from '../../events';
import { isInsideIframe } from '../../utils';

export class VehicleDetailPage {
    /**
     * @type {Swiper}
     */
    #thumbnailSwiper = null;
    /**
     * @type {Swiper}
     */
    #stockSwiper = null;
    /**
     * @type {number|null}
     */
    #swiperWaiter = null;
    /**
     * @type {Document|HTMLElement}
     */
    #document;

    /**
     * @param {Document|ShadowRoot} document
     */
    constructor(document) {
        this.#document = document;
    }

    init() {
        if (!this.#document.querySelector('#stock-image-carousel')) {
            throw new Error('Stock image carousel not found');
        }

        this.#initializeSwiper();
        this.#bindNavigation();
        this.#setupFancybox();
        this.#initializeDrawers();
    }

    #initializeDrawers() {
        initDrawers(this.#document);
    }

    #initializeSwiper() {
        const thumbnailContainer = this.#document.getElementById('stock-thumbnail-carousel');
        const stockImageContainer = this.#document.getElementById('stock-image-carousel');
        const primarySliderOptions = {};

        if (thumbnailContainer) {
            this.#thumbnailSwiper = new Swiper(thumbnailContainer, {
                spaceBetween: 10,
                slidesPerView: 4,
                watchSlidesProgress: true,
                breakpoints: {
                    '@0.5': {
                        slidesPerView: 4,
                    },
                    '@0.75': {
                        slidesPerView: 6,
                    },
                },
            });

            primarySliderOptions.thumbs = {
                swiper: this.#thumbnailSwiper,
            };
        }

        this.#stockSwiper = new Swiper(stockImageContainer, {
            ...primarySliderOptions,
            modules: [Keyboard, Navigation, Thumbs, Pagination],
            slidesPerView: 1,
            freeMode: true,
            watchSlidesProgress: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            navigation: {
                nextEl: stockImageContainer.querySelector('.swiper-button-next'),
                prevEl: stockImageContainer.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: stockImageContainer.querySelector('.swiper-pagination'),
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 3,
            },
            on: {
                afterInit: () => {
                    window.dispatchEvent(new CustomEvent(StockEvents.DETAIL_PAGE_COMPONENTS.SWIPER_INITIALIZED));
                },
            },
        });
    }

    #bindNavigation() {
        for (const element of this.#document.querySelectorAll('.vehicle-navigation [data-navbar] a[href^="#"]')) {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                const item = element.attributes.getNamedItem('href').textContent;
                this.#document.querySelector(item).scrollIntoView();
            });
        }
    }

    #setupFancybox() {
        Fancybox.bind(this.#document.getElementById('stock-image-carousel'), '[data-fancybox]', {
            parentEl: this.#document.host?.shadowRoot.querySelector('body') || null,
            Toolbar: {
                display: {
                    right: ['close'],
                },
            },
            on: {
                done: (fancybox, slide) => {
                    if (this.#swiperWaiter) {
                        clearTimeout(this.#swiperWaiter);
                    }
                    this.#swiperWaiter = setTimeout(() => this.#stockSwiper.slideTo(slide.index - 1), 100);
                },
            },
        });
        for (const button of this.#document.querySelectorAll('[data-fancybox-open]')) {
            const target = this.#document.getElementById(button.dataset.fancyboxOpen);
            button.addEventListener('click', (e) => {
                e.preventDefault();
                target.click();
            });
        }
    }
}
